<template>
  <div>
    <!-- 尾 -->
    <footer v-if="FooterData">
      <div class="container">
        <div class="footer_main">
          <div class="text_box">
            <img class="logo_gcit" src="img/logo_gcit.svg" alt="">
            <div class="text" v-html="FooterData.Footer_Text">
            </div>
          </div>
          <div class="logo">
            <template v-if="FooterData.Logo_Image_1">
              <a :href="FooterData.Logo_Url_1"><img :src="FooterData.SiteUrl + FooterData.Logo_Image_1" alt=""></a>
            </template>
            <template v-if="FooterData.Logo_Image_2">
              <a :href="FooterData.Logo_Url_2"><img :src="FooterData.SiteUrl + FooterData.Logo_Image_2" alt=""></a>
            </template>
          </div>
        </div>
      </div>
      <div class="bottom">
        <p>Copyright ©2022 Master’s Program in Global Communication and Innovation Technology, NCCU.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

//import { Fragment } from 'vue-fragment'

const messages = {
  zh_tw: {
  },
  en: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "FooterBlock",
  i18n,
  components: {
    //Fragment,
    Slick,
  },
  data() {
    return {
      FooterData: null,
      local: "zh_tw",
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/GCIT/Footer",
        {
          params: { lang: $cookies.get("gcit_the_site_lang") },
        }
      )
      .then((response) => {
        this.FooterData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("gcit_the_site_lang")) {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = $cookies.get("gcit_the_site_lang");
    } else {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = "zh_tw";
    }
  },
  methods: {
    changeLang(lang) {
      $cookies.set("gcit_the_site_lang", lang, "30d");
      location.reload();
    },
    goto: function (MenuData) {
      if (MenuData.Type == 1) {
        this.gotoCategoryByCId(MenuData.CId);
      } else if (MenuData.Type == 2) {
        this.gotoPostByPId(MenuData.PId);
      } else if (MenuData.Type == 3) {
        this.gotoUrl(MenuData.Url, MenuData.Blank);
      }
    },
  },
};
</script>
